<template>
  <div id="app">
    <header-banner></header-banner>
    <router-view/>
      <footer-banner></footer-banner>
      <gdprBar theme="dark-lime" buttonLink="/privacy"></gdprBar>
  </div>
</template>

<script>
import Header from './components/navigation/Header'
import Footer from './components/navigation/Footer'
import CookieLaw from 'vue-cookie-law'
export default {
  components: {
    headerBanner: Header,
    footerBanner: Footer,
    gdprBar: CookieLaw
  }
}
</script>

<style>
html, body {
  margin: 0 auto;
  padding: 0;
}
.appleFont {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0 auto;
  padding: 0;
}

/* Showrooms CSS */
.showroomMenu {
  display: none;
  padding: 0;
  margin: 0 auto;
  background: linear-gradient(#fff, #4e606e);
  height: 400px;
}

.showroomMenu ul {
  padding: 0;
  margin: 0 auto;
  overflow-y: scroll;
  min-height: calc(150vh - 50px);
}

.showroomMenu li {
  position: relative;
  text-align: center;
  margin: 0 auto;
  list-style-type: none;
  padding-bottom: 5px;
  padding-top: 15px;
  padding-left: 0px;
  padding-right: 15px;
  width: 100%;
}

.showroomMenu li:hover {
  background-color: #3f96c2;
}

.showroomMenu a {
  text-decoration: none;
  color: darkslategrey;
  font-size: 26px;
}

.showroomMenu a:hover {
  color: silver;
  cursor:pointer;
}

.showroomSlide {
  position: relative;
  background-color: #f2f2f2;
  width: 100%;
  padding: 0;
  margin: 0 auto;
  padding-top: 55px;
}

.showroomSlide img {
  position: relative;
}

.showroomSlide > h1 {
  position: relative;
  text-align: center;
  padding-top: 100px;
  padding-bottom: 20px;
  margin: 0 auto;
}

.button-container {
  position: relative;
  top: 10px;
  margin: 0 auto;
  text-align: center;
  height: 100px;
  width: 70%;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
  padding-right: 0px;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}

.button-container2 {
  position: relative;
  margin: 0 auto;
  text-align: center;
  height: 150px;
  width: 50%;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
  padding-right: 0px;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}

#change-image {
  position: relative;
  width: 80%;
  display: block;
  margin: 0 auto;
  text-align: center;
}

.button-container ul,
.button-container2 ul {
  text-decoration: none;
}

.button-container li,
.button-container2 li {
  position: relative;
  margin: 0 auto;
  width: 20%;
  padding: 10px;
  display: inline-block;
  clear: both;
  list-style-type: none;
}

.button-container img:hover,
.button-container2 img:hover {
  opacity: 0.5;
}

.button-container li a,
.button-container2 li a {
  display: block;
}

.button-container img,
.button-container2 img {
  max-width: 100%;
}

/*Modal*/
#img1,
#img2,
#img3,
#img4,
#img5,
#img6,
#img7,
#img8,
#img9,
#img10,
#img11,
#img12,
#img13,
#img14,
#img15,
#img16,
#img17,
#img18,
#img19,
#img20,
#img21,
#img22,
#img23,
#img24,
#img25,
#img26,
#img27,
#img28,
#img29,
#img30 {
  cursor: pointer;
  transition: 0.3s;
}

/*Modal Background*/
.modal {
  display: none;
  position: fixed;
  z-index: 9999999999;
  padding-top: 100px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: scroll;
  background-color: rgb(0, 0, 0);
  background-color: rgb(0, 0, 0, 0.9);
}

/*Content*/
.modal-content {
  margin: auto;
  display: block;
  width: 100%;
  max-width: 700px;
  border-radius: 8px;
  box-shadow: none;
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
}

/*Caption*/
#caption {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
  text-align: center;
  color: #fff;
  padding: 10px 0;
  height: 100%;
}

/*Animate This*/
.modal-content,
#caption {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.7s;
  animation-name: zoom;
  animation-name: 0.7s;
}

@-webkit-keyframes zoom {
  from {
    -webkit-transform: scale(0);
  }

  to {
    -webkit-transform: scale(1);
  }
}

/*Close This*/
.close {
  position: absolute;
  top: 15px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.4s;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

/* Failure/Success CSS */
.messageContainer {
  position: relative;
  top: 100px;
  padding-top: 50px;
  padding-bottom: 50px;
  width: 100%;
  background-color: #f2f2f2;
  box-shadow: 3px 5px 5px darkgrey;
}

.messageTitle {
  position: relative;
  margin-left: 100px;
  font-size: 36px;
}

.message {
  position: relative;
  margin-left: 300px;
  font-size: 20px;
}

#btn {
  position: relative;
  margin-left: 60%;
  padding: 10px;
  font-size: 16px;
  border-radius: 2px;
  box-shadow: 3px 5px 5px lightgrey;
  background-color: slategrey;
  color: white;
}

#terms {
  position: fixed;
  padding-top: 15px;
  padding-bottom: 15px;
  background: radial-gradient(#fff, #f2f2f2);
  width: 350px;
  bottom: 0;
  margin: 0 auto;
  box-shadow: 3px 3px 4px #000;
  -moz-box-shadow: 3px 3px 4px #000;
  -webkit-box-shadow: 3px 3px 4px #000;
  z-index: 9999;
}

#terms p {
  position: relative;
  text-align: center;
  padding-bottom: 5px;
  margin: 0 auto;
  width: 80%;
  color: black;
}

#terms a {
  text-decoration: none;
}

#close-terms {
  position: relative;
  color: black;
  float: right;
  left: 5%;
  top: 10px;
  text-decoration: none;
}

@media (min-width: 320px) {
    #showButton {
    position: relative;
    bottom: 5px;
    color: white;
    font-size: 16px;
    background-color: #4E606E;
    border: 10px solid #4E606E;
    width: 100%;
    margin: 0 auto;
  }

  #showButton:hover {
    color: silver;
    cursor: pointer;
  }
}

 @media (min-width: 375px) {
    .showroomSlide {
      min-height: calc(80vh - 50px) !important;
    }
  }

  @media (min-width: 414px) {
  .showroomSlide {
    padding-top: 55px;
      min-height: calc(100vh - 50px);
    }
}

 @media (min-width: 568px) {
    .showroomSlide>h1, .showroomSlide>img, .button-container {
      top: 0 !important;
    }
  }

  @media (min-width: 812px) {
  .showroomSlide {
    padding-top: 55px;
    padding-bottom: 100px;
      min-height: calc(00vh - 0px);
    }
}

 @media (min-width: 1024px) {
/* Showroom CSS */
    #change-image {
      width: 60%;
    }

    .showroomSlide {
      position: relative;
      width: 80%;
      float: right;
      margin: 0;
      padding-top: 100px;
      padding-bottom: 300px;
    }
    .showroomSlide > img {
      position: relative;
      top: 300px;
    }

    .showroomSlide>h1 {
      top: 75px;
      padding-top: 40px;
      padding-bottom: 40px;
    }
.showroomMenu a {
  font-size: 16px;
 }

  .button-container {
      height: 100px;
    }

    .button-container2 {
      height: 150px;
    }

    .button-container img {
      top: 0;
      display: block;
      margin: 0 auto;
    }

    .button-container2 img {
      top: 0;
      display: block;
      margin: 0 auto;
    }

    .showroomMenu {
      display: block;
      position: fixed;
      height: 100%;
      width: 20%;
      background-color: #D3D4D8 !important;
      background: none;
      float: left;
      top: 0;
      bottom: 0;
      overflow-y: auto;
    }

    .showroomMenu ul {
      position: relative;
      margin: 0 auto;
      max-height: 50%;
      right: 10px;
      padding: 0;
    }

    .showroomMenu li {
      position: relative;
      text-align: left;
      top: 95px;
      width: 80%;
      padding-top: 40px;
      padding-bottom: 40px;
      padding-right: 40px;
      padding-left: 10px;
      list-style-type: none;
      border-top-right-radius: 15px;
      border-bottom: #f2f2f2 solid 1px;
    }

    .showroomMenu li:last-child {
      border-bottom: none;
    }

    .showroomMenu li:hover {
      background-color: #3F96C2;
      transition: 1s;
    }

    .showroomMenu a {
      position: relative;
      left: 10px;
      text-decoration: none;
    }

    .showroomMenu a:hover {
      color: #f2f2f2;
    }

    #showButton {
      display: none;
    }
 }
</style>
